import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Grid,
  GridItem,
  Image,
  Divider,
  Flex,
  Link,
  Button,
  ButtonGroup,
} from "@chakra-ui/react";
import CuLogo from "../assets/cu-logo-head.png";
import Textprocil from "../../../assets/Texprocil.png";
import Card from "../../../Components/TraceApp/VerificationCard/Card";
import { CottonIcon, ForwardIcon, Loader } from "../assets/Icons";
import { useNavigate, useParams } from "react-router-dom";
import FarmersDetails from "./FarmersDetails";
import axios from "axios";
import { useCallback } from "react";
import { getClientTrace, getTcDetailFoTrace } from "./api";

function HomePageV3({ id, traceVersion }) {
  const [traceDetails, setTraceDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("Farmer");

  const desiredSequence = [
    "Farmers",
    "APMC",
    "Broker",
    "Ginning",
    "Spinning",
    "Trading",
    "Knitting",
    "Weaving",
    "Pre-treatment",
    "Dyeing",
    "Garmenting",
    "Retail",
    "Dispatching",
    "Boiling",
    "Brand",
    "Breeding",
    "Chemical recycling",
    "Concentrating",
    "Down processing",
    "Collecting",
    "Embroidery/Embellishment",
    "Extrusion",
    "Farming (group)",
    "Farming (individual)",
    "Farming (communal)",
    "Farming (area)",
    "Finishing",
    "Molding",
    "Mechanical Recycling",
    "No processing",
    "Manufacturing",
    "Non-woven Manufacturing",
    "Packing",
    "Preparatory",
    "Others",
    "Printing",
    "Scouring",
    "Pulp making",
    "Retting",
    "Retail Sales",
    "Slaughtering",
    "Tanning",
    "Top Making",
    "Washing, laundering",
    "Warehousing, Distribution",
    "Write off / Dummy",
    "Hatching",
  ];

  // API call to get trace details
  const getTraceDetails = async (id, traceVersion) => {
    setIsLoading(true);
    try {
      const res = await getClientTrace(id, traceVersion);
      if (res?.status === "success") {
        setTraceDetails(res?.data);
      }
    } catch (error) {
      console.log(error.message);
    }
    setIsLoading(false);
  };

  // useEffect(() => {
  //   getTraceDetails(id);
  //   localStorage.setItem(id, "id");
  // }, [id]);

  useEffect(() => {
    if (id && traceVersion !== undefined) {
      getTraceDetails(id, traceVersion);
      localStorage.setItem(id, "id");
    }
  }, [id, traceVersion]);

  const navigate = useNavigate();
  const handleGoDetail = useCallback(
    (category, company) => {
      navigate(`./${category}`, {
        state: { company: company, traceVersion: traceVersion },
      });
    },
    [navigate]
  );

  useEffect(() => {
    const uniqueCategories = {};
    Object.keys(traceDetails || {}).forEach((key) => {
      const uniqueLocations = {};
      traceDetails[key]?.forEach((obj) => {
        const state =
          obj?.tc_seller?.address?.state ||
          obj?.address?.state ||
          obj?.address?.state;

        const city =
          obj?.tc_seller?.address?.city ||
          obj?.address?.city ||
          obj?.address?.city;

        let sellerName = "Unknown";

        if (key === "Farmers") {
          const firstName = obj?.firstName?.trim() || "";
          const lastName = obj?.lastName?.trim() || "";
          sellerName = `${firstName} ${lastName}`.trim() || "Unknown";
        } else {
          sellerName = obj?.tc_seller?.name || obj?.address?.name || "Unknown";
        }

        const inputProduct = [
          ...new Set(
            obj?.products?.flatMap(
              (product) =>
                product?.inputs?.map(
                  (input) => input?.productClassification?.name
                ) || []
            )
          ),
        ];

        const outputProduct = [
          ...new Set(
            obj?.products?.map(
              (el) => el?.productId?.product_productClassification?.name
            )
          ),
        ];

        if (!uniqueLocations[state]) {
          uniqueLocations[state] = {
            cities: [],
            sellerNames: [],
            inputProduct: [],
            outputProduct: [],
            certifiedWeight: 0,
          };
        }

        if (!uniqueLocations[state].cities.includes(city)) {
          uniqueLocations[state].cities.push(city);
        }

        if (!uniqueLocations[state].sellerNames.includes(sellerName)) {
          uniqueLocations[state].sellerNames.push(sellerName);
        }

        inputProduct.forEach((input) => {
          if (!uniqueLocations[state].inputProduct.includes(input)) {
            uniqueLocations[state].inputProduct.push(input);
          }
        });

        outputProduct.forEach((output) => {
          if (!uniqueLocations[state].outputProduct.includes(output)) {
            uniqueLocations[state].outputProduct.push(output);
          }
        });

        const totalCertifiedWeight = obj?.products?.reduce((sum, p) => {
          return sum + (p?.certifiedWeight || 0);
        }, 0);

        uniqueLocations[state].certifiedWeight += totalCertifiedWeight;
      });

      uniqueCategories[key] = uniqueLocations;
    });

    const reorderedData = desiredSequence.reduce((acc, process) => {
      if (uniqueCategories[process]) {
        acc[process] = uniqueCategories[process];
      }
      return acc;
    }, {});

    Object.keys(uniqueCategories).forEach((key) => {
      if (!reorderedData[key]) {
        reorderedData[key] = uniqueCategories[key];
      }
    });

    setCategories(reorderedData);
  }, [traceDetails]);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  if (!id || traceVersion === undefined) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        width="100%"
      >
        <Loader width="80px" height="80px" color="#3958DC" />
      </Box>
    );
  }

  return (
    <>
      {isLoading ? (
        <Box marginTop={"2rem"} textAlign={"center"}>
          <Loader width="50px" height="50px" color="#3958DC" />
          <Text fontSize="16px" fontWeight={"700"} marginTop={"10px"}>
            Loading the Trace...
          </Text>
        </Box>
      ) : (
        <Box bg="white" maxW="480px">
          <Box
            bg="#EFEFF4"
            width={"100%"}
            borderBottomRadius={"15px"}
            boxShadow={"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
          >
            <Grid templateColumns="repeat(2, 1fr)" pb="1rem" px="2rem">
              <GridItem>
                {/* <Text fontSize={"15px"} fontWeight={"800"}>
                  Howdy,
                </Text>
                <Text fontSize={"15px"} fontWeight={"400"}>
                  It’s a nice day
                </Text> */}
                <Image
                  src={Textprocil}
                  h="70px"
                  w="160px"
                  alt="Control Union"
                />
              </GridItem>
              <GridItem justifySelf={"end"} pt="0.65rem">
                <Link
                  href="https://certifications.controlunion.com/en"
                  target="_blank"
                >
                  <Image boxSize="55px" src={CuLogo} alt="Control Union" />
                </Link>
              </GridItem>
            </Grid>
          </Box>

          <Card id={id} traceVersion={traceVersion} />

          <Box mx={"2rem"}>
            <Box display={"flex"} alignItems={"center"} my={"2rem"}>
              <CottonIcon mt="10px" /> &nbsp;
              <Text fontSize="14px" fontWeight={"400"} mt={"0.5rem"}>
                100% Cotton From Certified Farmers
              </Text>
            </Box>

            {/* <ButtonGroup
              size="md"
              isAttached
              variant="outline"
              mt="1rem"
              borderRadius="15px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              spacing={"6"}
            >
              {["Farmer", "APMC", "Broker"].map((category) => (
                <Button
                  key={category}
                  onClick={() => handleCategoryChange(category)}
                  colorScheme={selectedCategory === category ? "white" : "gray"}
                  color={"black"}
                  variant={selectedCategory === category ? "solid" : "outline"}
                  bg={selectedCategory === category ? "white" : "gray.200"}
                  boxShadow={
                    selectedCategory === category
                      ? "0 2px 4px rgba(0, 0, 0, 0.2)"
                      : "none"
                  }
                  borderRadius={"15px"}
                >
                  {category}
                </Button>
              ))}
            </ButtonGroup> */}
            <ButtonGroup
              size="md"
              isAttached
              variant="outline"
              mt="1rem"
              borderRadius="15px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              spacing={"6"}
            >
              {["Farmers", "APMC", "Broker"]
                .filter((category) => category in categories)
                .map((category) => (
                  <Button
                    key={category}
                    onClick={() => handleCategoryChange(category)}
                    colorScheme={
                      selectedCategory === category ? "white" : "gray"
                    }
                    color={"black"}
                    variant={
                      selectedCategory === category ? "solid" : "outline"
                    }
                    bg={selectedCategory === category ? "white" : "gray.200"}
                    boxShadow={
                      selectedCategory === category
                        ? "0 2px 4px rgba(0, 0, 0, 0.2)"
                        : "none"
                    }
                    borderRadius={"15px"}
                  >
                    {category}
                  </Button>
                ))}
            </ButtonGroup>

            {/* Render only the selected category */}
            {categories[selectedCategory] && (
              <Box mt="1rem" mb="2rem" mx="0.5rem">
                <Grid templateColumns="2fr 0.2fr">
                  <GridItem>
                    <Grid templateColumns="1fr 1fr 1fr">
                      <GridItem my="20px">
                        <Flex
                          flexDirection="column"
                          justifyContent="space-between"
                          height="100%"
                        >
                          <Box>
                            <Text fontSize="12px" fontWeight="500">
                              Input Product
                            </Text>
                            {Object.keys(categories[selectedCategory]).map(
                              (state) =>
                                categories[selectedCategory][
                                  state
                                ].inputProduct.map((input) => (
                                  <Text
                                    color="#AFAFAF"
                                    fontSize="12px"
                                    key={input}
                                  >
                                    {input}
                                  </Text>
                                ))
                            )}
                          </Box>

                          <Text w="84px" color="#D9D9D9">
                            ----------
                          </Text>

                          <Box>
                            <Text fontSize="12px" fontWeight="500">
                              Output Product
                            </Text>
                            {/* {Object.keys(categories[selectedCategory]).map(
                              (state) =>
                                categories[selectedCategory][
                                  state
                                ].outputProduct.map((output) => (
                                  <Text
                                    color="#AFAFAF"
                                    fontSize="12px"
                                    key={output}
                                  >
                                    {output || "Sed Cotton (raw cotton)"}
                                  </Text>
                                ))
                            )} */}
                            {Object.keys(categories[selectedCategory]).map(
                              (state) => {
                                const outputProducts =
                                  categories[selectedCategory][state]
                                    ?.outputProduct;
                                if (
                                  !outputProducts ||
                                  outputProducts.length === 0
                                ) {
                                  return (
                                    <Text
                                      color="#AFAFAF"
                                      fontSize="12px"
                                      key={`${state}-fallback`}
                                    >
                                      Seed Cotton (raw cotton)
                                    </Text>
                                  );
                                }

                                return outputProducts.map((output, index) => (
                                  <Text
                                    color="#AFAFAF"
                                    fontSize="12px"
                                    key={`${state}-output-${index}`}
                                  >
                                    {output || "Seed Cotton (raw cotton)"}
                                  </Text>
                                ));
                              }
                            )}
                          </Box>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Box
                          w="14px"
                          bg={
                            selectedCategory === "Farmer"
                              ? "#9CE8B3"
                              : selectedCategory === "APMC"
                              ? "#477AD4"
                              : "#EC806A"
                          }
                          height="100%"
                          mx="2rem"
                          borderRadius="10px"
                        />
                      </GridItem>
                      <GridItem>
                        <Box my="1rem">
                          <Text fontSize="15px" fontWeight="700">
                            {selectedCategory}
                          </Text>
                          {Object.keys(categories[selectedCategory]).map(
                            (state, index, array) => (
                              <Text
                                fontSize="12px"
                                fontWeight="400"
                                as="span"
                                key={state}
                              >
                                {state}
                                {index < array.length - 1 ? ", " : ""}
                              </Text>
                            )
                          )}
                          <Box
                            fontSize="12px"
                            color="#AFAFAF"
                            whiteSpace="normal"
                          >
                            {Object.keys(categories[selectedCategory]).map(
                              (state) => {
                                const sellerNames =
                                  categories[selectedCategory][state]
                                    .sellerNames;
                                return (
                                  <Box key={state}>
                                    {sellerNames.map((sellerName, index) => (
                                      <span key={sellerName}>
                                        {sellerName}
                                        {index !== sellerNames.length - 1
                                          ? ", "
                                          : ""}
                                      </span>
                                    ))}
                                  </Box>
                                );
                              }
                            )}
                          </Box>
                        </Box>
                        <GridItem display={"flex"} justifyContent={"end"}>
                          <ForwardIcon
                            mt="1rem"
                            onClick={() =>
                              navigate("./Farmer", {
                                state: { traceVersion: traceVersion },
                              })
                            }
                          />
                        </GridItem>
                      </GridItem>
                    </Grid>
                  </GridItem>
                </Grid>
              </Box>
            )}

            {desiredSequence
              .filter(
                (category) => !["Farmers", "Broker", "APMC"].includes(category)
              )
              .map(
                (category) =>
                  categories[category] && (
                    <Box key={category} mt="1rem" mb="2rem" mx="0.5rem">
                      <Grid templateColumns="2fr 0.2fr">
                        <GridItem>
                          <Grid templateColumns="1fr 1fr 1fr">
                            <GridItem my="20px">
                              <Flex
                                flexDirection="column"
                                justifyContent="space-between"
                                height="100%"
                              >
                                <Box>
                                  <Text fontSize="12px" fontWeight="500">
                                    Input Product
                                  </Text>
                                  {Object.keys(categories[category]).map(
                                    (state) =>
                                      categories[category][
                                        state
                                      ].inputProduct.map((input) => (
                                        <Text
                                          color="#AFAFAF"
                                          fontSize="12px"
                                          key={input}
                                        >
                                          {input}
                                        </Text>
                                      ))
                                  )}
                                </Box>

                                <Text w="84px" color="#D9D9D9">
                                  ----------
                                </Text>

                                <Box>
                                  <Text fontSize="12px" fontWeight="500">
                                    Output Product
                                  </Text>
                                  {Object.keys(categories[category]).map(
                                    (state) =>
                                      categories[category][
                                        state
                                      ].outputProduct.map((output) => (
                                        <Text
                                          color="#AFAFAF"
                                          fontSize="12px"
                                          key={output}
                                        >
                                          {output}
                                        </Text>
                                      ))
                                  )}
                                </Box>
                              </Flex>
                            </GridItem>
                            <GridItem>
                              <Box
                                w="14px"
                                bg={
                                  category === "Farmer"
                                    ? "#9CE8B3"
                                    : category === "APMC"
                                    ? "#477AD4"
                                    : "#EC806A"
                                }
                                height="100%"
                                mx="2rem"
                                borderRadius="10px"
                              />
                            </GridItem>
                            <GridItem>
                              <Box my="1rem">
                                <Text fontSize="15px" fontWeight="700">
                                  {category}
                                </Text>
                                {Object.keys(categories[category]).map(
                                  (state, index, array) => (
                                    <Text
                                      fontSize="12px"
                                      fontWeight="400"
                                      as="span"
                                      key={state}
                                    >
                                      {state}
                                      {index < array.length - 1 ? ", " : ""}
                                    </Text>
                                  )
                                )}
                                <Box fontSize="12px" color="#AFAFAF">
                                  {Object.keys(categories[category]).map(
                                    (state) =>
                                      categories[category][
                                        state
                                      ].sellerNames.map((sellerName) => (
                                        <span key={sellerName}>
                                          {sellerName}
                                        </span>
                                      ))
                                  )}
                                </Box>
                              </Box>
                              <GridItem display={"flex"} justifyContent={"end"}>
                                <ForwardIcon
                                  mt="0.5rem"
                                  onClick={() =>
                                    handleGoDetail(
                                      category,
                                      categories[category]
                                    )
                                  }
                                />
                              </GridItem>
                            </GridItem>
                          </Grid>
                        </GridItem>
                      </Grid>
                    </Box>
                  )
              )}
          </Box>
        </Box>
      )}
    </>
  );
}

export default HomePageV3;
